import React, { useState } from "react";
import "../UserAccountTransfers.scss";
import { Box, Typography } from "@mui/material";
// import MoneyGram from "../../../../images/moneygram.svg";
import MoneyGram from "../../../../images/MG_IconRed.svg";
import RIALogo from "../../../../images/Ria.svg";
import BPILogo from "../../../../images/BPI.svg";
import WesternUnionLogo from "../../../../images/WesternUnion.svg";
import Emerlink from "../Emerlink";
import RIA from "../RIA";
import InternationalTransfersLogo from "./InternationalTransfersLogo";
import BPI from "../BPI";
import WesternUnion from "../WesternUnion";
import { serviceUrl } from "../../../../config";
import Moneygram from "../Moneygram";
import { useSelector } from "react-redux";

function InternationalTransfers() {
  const [remittancePartner, setRemittancePartner] = useState(null);
  let configVariables = useSelector((state) => state.config.baseConfig);
  let isDevEnv = configVariables.devEnvironment;

  const handleClick = (partnerName) => {
    setRemittancePartner(partnerName);
  }

  const BACKEND_URL = serviceUrl;

  const renderPartnerComponent = () => {
    switch (remittancePartner) {
      case "Emerlink":
        return <Emerlink handleBack={handleBack} />;
      case "RIA":
        return <RIA handleBack={handleBack} />
      case "BPI":
        return <BPI handleBack={handleBack} />
      case "WesternUnion":
        return <WesternUnion handleBack={handleBack} />
      case "Moneygram2":
        return <Moneygram handleBack={handleBack} />
      default:
        return null;
    }
  }

  const handleBack = () => {
    setRemittancePartner(null);
  };

  return (
    <Box>
      {renderPartnerComponent() ? renderPartnerComponent() :
        <Box className="mt-4">

          <Typography
            display="flex"
            justifyContent="center"
            className="fw-bold">
            Select a provider
          </Typography>

          <Box display="flex" className="mt-4" justifyContent="space-around">

            <InternationalTransfersLogo
              logo={MoneyGram}
              name="Moneygram (Emerlink)"
              handleClick={() => handleClick("Emerlink")}
            />
          <InternationalTransfersLogo
              logo={MoneyGram}
              name="Moneygram (Direct)"
              handleClick={() => handleClick("Moneygram2")}
            />
            <InternationalTransfersLogo
              logo={RIALogo}
              name="RIA"
              handleClick={() => handleClick("RIA")}
            />

            <InternationalTransfersLogo
              logo={BPILogo}
              name="BPI"
              handleClick={() => handleClick("BPI")}
            />

            {/* <InternationalTransfersLogo
              logo={MoneyGram}
              name="Send MoneyGram"
              handleClick={() => handleClick("Moneygram2")}
            /> */}

            {/* {BACKEND_URL !== 'https://paiyhub.ncsfsg.com/php/Workflows/services.php?output=json' && <InternationalTransfersLogo
              logo={RIALogo}
              name="RIA"
              handleClick={() => handleClick("RIA")}
            />} */}

            {/* {BACKEND_URL !== 'https://paiyhub.ncsfsg.com/php/Workflows/services.php?output=json' && <InternationalTransfersLogo
              logo={BPILogo}
              name="BPI"
              handleClick={() => handleClick("BPI")}
            />} */}

            {BACKEND_URL !== 'https://paiyhub.ncsfsg.com/php/Workflows/services.php?output=json' && isDevEnv && <InternationalTransfersLogo
              logo={WesternUnionLogo}
              name="Western Union"
              handleClick={() => handleClick("WesternUnion")}
            />}

            {/* {BACKEND_URL !== 'https://paiyhub.ncsfsg.com/php/Workflows/services.php?output=json' && isDevEnv && <InternationalTransfersLogo */}
            {/* {BACKEND_URL !== 'https://paiyhub.ncsfsg.com/php/Workflows/services.php?output=json' && <InternationalTransfersLogo
              logo={MoneyGram}
              name="Moneygram 2"
              handleClick={() => handleClick("Moneygram2")}
            />} */}

          </Box>

        </Box>
      }
    </Box>
  );
}

export default InternationalTransfers;